import React from 'react'

import numeral from 'numeral'

import {
  TagComponent, classnames, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, bool, string } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'


function ModelCardPrice({
  discount,
  originalPrice,
  price,
  ribbon = null,
  isVisible,
  modelId,
}) {
  const pageConfig = usePageConfig()
  const { currentUserIsAdmin: isAdminViewer } = pageConfig || {}

  const isFreeModel = discount === 0 && originalPrice === 0

  const getPrice = (value, format = '$0.00') => {
    return numeral(value).format(format)
  }

  function renderDiscountTag() {
    if (discount !== 0) {
      if (isAdminViewer) {
        return (
          <Tooltip
            content={ribbon}
            id={modelId}
            offset={{ top: 10 }}
            disableMobileEvent
          >
            <TagComponent
              type="primary"
              color="warning"
              className="card-3d-model__discount-tag"
            >
              -{getPrice(discount, '0%')}
            </TagComponent>
          </Tooltip>
        )
      }
      return (
        <TagComponent
          type="primary"
          color="warning"
          className="card-3d-model__discount-tag"
        >
          -{getPrice(discount, '0%')}
        </TagComponent>
      )
    }

    return null
  }

  function renderPriceTag() {
    return (
      <TagComponent
        type="secondary"
        hasBorder
        backColor="white-100"
        className="card-3d-model__price-tag"
      >
        {isFreeModel ? 'FREE' : getPrice(price).replace('.00', '')}
      </TagComponent>
    )
  }

  if (price < 0) {
    return null
  }

  return (
    <div className={classnames(
      'card-3d-model__price',
      isVisible && 'card-3d-model__price--visible',
    )}
    >
      {renderDiscountTag()}
      {renderPriceTag()}
    </div>
  )
}

ModelCardPrice.propTypes = {
  discount: number.isRequired,
  originalPrice: number.isRequired,
  price: number.isRequired,
  ribbon: string,
  isVisible: bool.isRequired,
  modelId: string.isRequired,
}

export default ModelCardPrice
